const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": true,
        "Type": "mosaics",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "66%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "listTitle-default",
                "Type": "listTitle",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": true,
                        "style": "body",
                        "fontWeight": "bold",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Visibility": {
                        "ListTitle": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "center"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "50%",
                        "col2_width": "50%",
                        "col1_verticalAlign": "middle",
                        "col2_verticalAlign": "middle",
                        "col2_collapseIfEmpty": true,
                        "columnCount": "2",
                        "itemsPerPage": "4"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "itemImage-default",
                            "Type": "itemImage",
                            "Config": {
                                "Block": {
                                    "maxWidth": "75%",
                                    "maxHeight": "400px"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemArtist-default",
                            "Type": "itemArtist",
                            "Config": {
                                "Block": {
                                    "style": "header",
                                    "fontWeight": "bold",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemTitle-default",
                            "Type": "itemTitle",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "textTransform": "none"
                                },
                                "Includes": {
                                    "Edition": true,
                                    "Date": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemMedium-default",
                            "Type": "itemMedium",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Medium": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemSignature-default",
                            "Type": "itemSignature",
                            "Config": {
                                "Block": {
                                    "textLabel": "Signature: ",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Signature": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemDimensions-default",
                            "Type": "itemDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Dimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemAlternateDimensions-default",
                            "Type": "itemAlternateDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "AlternateDimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemFramed-default",
                            "Type": "itemFramed",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Framed": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemPrice-default",
                            "Type": "itemPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Price": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                },
                                "Format": {}
                            }
                        },
                        {
                            "Id": "itemDisplayPrice-default",
                            "Type": "itemDisplayPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "DisplayPrice": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemLocation-default",
                            "Type": "itemLocation",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Location": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemNumber-default",
                            "Type": "itemNumber",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Number": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "itemSKU-default",
                            "Type": "itemSKU",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "SKU": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            }
        ],
        "Migration": {
            "itemFramed": true,
            "itemSignature": true
        }
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "mosaics",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "66%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "listTitle-default",
                "Type": "listTitle",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": true,
                        "style": "body",
                        "fontWeight": "bold",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Visibility": {
                        "ListTitle": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "center"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "50%",
                        "col2_width": "50%",
                        "col1_verticalAlign": "middle",
                        "col2_verticalAlign": "middle",
                        "col2_collapseIfEmpty": true,
                        "columnCount": "2",
                        "itemsPerPage": "4"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "itemImage-default",
                            "Type": "itemImage",
                            "Config": {
                                "Block": {
                                    "maxWidth": "75%",
                                    "maxHeight": "400px"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemArtist-default",
                            "Type": "itemArtist",
                            "Config": {
                                "Block": {
                                    "style": "header",
                                    "fontWeight": "bold",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemTitle-default",
                            "Type": "itemTitle",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "textTransform": "none"
                                },
                                "Includes": {
                                    "Edition": true,
                                    "Date": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemMedium-default",
                            "Type": "itemMedium",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Medium": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemSignature-default",
                            "Type": "itemSignature",
                            "Config": {
                                "Block": {
                                    "textLabel": "Signature: ",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Signature": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemDimensions-default",
                            "Type": "itemDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Dimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemAlternateDimensions-default",
                            "Type": "itemAlternateDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "AlternateDimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemFramed-default",
                            "Type": "itemFramed",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Framed": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemPrice-default",
                            "Type": "itemPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Price": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                },
                                "Format": {}
                            }
                        },
                        {
                            "Id": "itemDisplayPrice-default",
                            "Type": "itemDisplayPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "DisplayPrice": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemLocation-default",
                            "Type": "itemLocation",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Location": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemNumber-default",
                            "Type": "itemNumber",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Number": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "itemSKU-default",
                            "Type": "itemSKU",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "SKU": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            }
        ],
        "Migration": {
            "itemFramed": true,
            "itemSignature": true
        }
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "mosaics",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "listTitle-default",
                "Type": "listTitle",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": true,
                        "style": "body",
                        "fontWeight": "bold",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Visibility": {
                        "ListTitle": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "center"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "50%",
                        "col2_width": "50%",
                        "col1_verticalAlign": "middle",
                        "col2_verticalAlign": "middle",
                        "col2_collapseIfEmpty": true,
                        "columnCount": "2",
                        "itemsPerPage": "4"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "itemImage-default",
                            "Type": "itemImage",
                            "Config": {
                                "Block": {
                                    "maxWidth": "75%",
                                    "maxHeight": "400px"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemArtist-default",
                            "Type": "itemArtist",
                            "Config": {
                                "Block": {
                                    "style": "header",
                                    "fontWeight": "bold",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemTitle-default",
                            "Type": "itemTitle",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "textTransform": "none"
                                },
                                "Includes": {
                                    "Edition": true,
                                    "Date": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemMedium-default",
                            "Type": "itemMedium",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Medium": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemSignature-default",
                            "Type": "itemSignature",
                            "Config": {
                                "Block": {
                                    "textLabel": "Signature: ",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Signature": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemDimensions-default",
                            "Type": "itemDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Dimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemAlternateDimensions-default",
                            "Type": "itemAlternateDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "AlternateDimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemFramed-default",
                            "Type": "itemFramed",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Framed": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemPrice-default",
                            "Type": "itemPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Price": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                },
                                "Format": {}
                            }
                        },
                        {
                            "Id": "itemDisplayPrice-default",
                            "Type": "itemDisplayPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "DisplayPrice": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemLocation-default",
                            "Type": "itemLocation",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Location": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemNumber-default",
                            "Type": "itemNumber",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Number": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "itemSKU-default",
                            "Type": "itemSKU",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "SKU": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            }
        ],
        "Migration": {
            "itemFramed": true,
            "itemSignature": true
        }
    },
    {
        "Name": "Classic",
        "IsDefault": false,
        "Type": "mosaics",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "",
                    "paddingBottom": "",
                    "paddingLeft": "8px",
                    "paddingRight": "8px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "200px",
                        "maxHeight": "150px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "",
                        "paddingBottom": "40px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "listTitle-default",
                "Type": "listTitle",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": true,
                        "style": "body",
                        "fontWeight": "bold",
                        "fontStyle": "normal",
                        "textTransform": "none",
                        "fontSize": "16px",
                        "lineHeight": "19px"
                    },
                    "Visibility": {
                        "ListTitle": true
                    },
                    "Style": {
                        "paddingBottom": "22px",
                        "textAlign": "center"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "50%",
                        "col2_width": "50%",
                        "col1_verticalAlign": "middle",
                        "col2_verticalAlign": "middle",
                        "col2_collapseIfEmpty": true,
                        "columnCount": "2",
                        "itemsPerPage": "4",
                        "col1_paddingLeft": "3px",
                        "col1_paddingRight": "2px",
                        "col2_paddingLeft": "2px",
                        "col2_paddingRight": "3px",
                        "col1_paddingTop": "1px",
                        "col2_paddingTop": "1px",
                        "col1_paddingBottom": "2px",
                        "col2_paddingBottom": "2px"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "itemImage-default",
                            "Type": "itemImage",
                            "Config": {
                                "Block": {
                                    "maxWidth": "75%",
                                    "maxHeight": "400px"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemArtist-default",
                            "Type": "itemArtist",
                            "Config": {
                                "Block": {
                                    "style": "header",
                                    "fontWeight": "bold",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemTitle-default",
                            "Type": "itemTitle",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "textTransform": "none"
                                },
                                "Includes": {
                                    "Edition": true,
                                    "Date": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemMedium-default",
                            "Type": "itemMedium",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Medium": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemSignature-default",
                            "Type": "itemSignature",
                            "Config": {
                                "Block": {
                                    "textLabel": "Signature: ",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Signature": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemDimensions-default",
                            "Type": "itemDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Dimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemAlternateDimensions-default",
                            "Type": "itemAlternateDimensions",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "AlternateDimensions": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemFramed-default",
                            "Type": "itemFramed",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Framed": false
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemPrice-default",
                            "Type": "itemPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Price": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                },
                                "Format": {}
                            }
                        },
                        {
                            "Id": "itemDisplayPrice-default",
                            "Type": "itemDisplayPrice",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "DisplayPrice": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemLocation-default",
                            "Type": "itemLocation",
                            "Config": {
                                "Block": {
                                    "style": "body",
                                    "fontStyle": "normal",
                                    "textTransform": "none"
                                },
                                "Visibility": {
                                    "Location": true
                                },
                                "Style": {
                                    "textAlign": "center"
                                }
                            }
                        },
                        {
                            "Id": "itemNumber-default",
                            "Type": "itemNumber",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "Number": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "itemSKU-default",
                            "Type": "itemSKU",
                            "Config": {
                                "Block": {
                                    "textLabel": "",
                                    "style": "body",
                                    "fontStyle": "normal"
                                },
                                "Visibility": {
                                    "SKU": true
                                },
                                "Style": {
                                    "paddingRight": "20px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            }
        ],
        "Migration": {
            "itemFramed": true,
            "itemSignature": true
        }
    }
];

module.exports = Templates;